var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4462_2757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 13.3334V15.6667C6.66699 16.6002 6.66699 17.0669 6.84865 17.4234C7.00844 17.737 7.2634 17.992 7.57701 18.1518C7.93353 18.3334 8.40024 18.3334 9.33366 18.3334H15.667C16.6004 18.3334 17.0671 18.3334 17.4236 18.1518C17.7372 17.992 17.9922 17.737 18.152 17.4234C18.3337 17.0669 18.3337 16.6002 18.3337 15.6667V9.33341C18.3337 8.39999 18.3337 7.93328 18.152 7.57676C17.9922 7.26316 17.7372 7.00819 17.4236 6.8484C17.0671 6.66675 16.6004 6.66675 15.667 6.66675H13.3337M4.33366 13.3334H10.667C11.6004 13.3334 12.0671 13.3334 12.4236 13.1518C12.7372 12.992 12.9922 12.737 13.152 12.4234C13.3337 12.0669 13.3337 11.6002 13.3337 10.6667V4.33341C13.3337 3.39999 13.3337 2.93328 13.152 2.57676C12.9922 2.26316 12.7372 2.00819 12.4236 1.8484C12.0671 1.66675 11.6004 1.66675 10.667 1.66675H4.33366C3.40024 1.66675 2.93353 1.66675 2.57701 1.8484C2.2634 2.00819 2.00844 2.26316 1.84865 2.57676C1.66699 2.93328 1.66699 3.39999 1.66699 4.33341V10.6667C1.66699 11.6002 1.66699 12.0669 1.84865 12.4234C2.00844 12.737 2.2634 12.992 2.57701 13.1518C2.93353 13.3334 3.40024 13.3334 4.33366 13.3334Z",
    stroke: "#CECFD2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4462_2757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy05);
export default __webpack_public_path__ + "static/media/copy-05.34133cc7c02e726f28483603a3c9232a.svg";
export { ForwardRef as ReactComponent };